import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './projectenGrid.css';
import ProjectData from './ProjectData';


function ProjectenGrid({ enkelerij = false, animate = false, lightmode = false }) {
  const lijst = enkelerij ? ProjectData.slice(0, 4) : ProjectData;
  const startDelayIndex = Math.max(lijst.length -4, 0);

  useEffect(() => {
    if (!animate) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;

        if (entry.isIntersecting) {
          el.classList.add('show');
          el.style.pointerEvents = 'none';

          const delay = parseFloat(getComputedStyle(el).getPropertyValue('--delay')) || 0;
          const transitionDuration = 600;

          setTimeout(() => {
            el.style.pointerEvents = 'auto';
          }, delay + transitionDuration);
        }
      });
    });

    const hiddenElements = document.querySelectorAll('.Project');
    hiddenElements.forEach((el) => observer.observe(el));
    
    return () => hiddenElements.forEach((el) => observer.unobserve(el));
  }, [animate]);
  
  return (
    <div className={`grid-projecten ${lightmode ? 'light' : 'dark'}`}>
      {lijst.map((project, index) => {
        const isDelayed = index >= startDelayIndex;
        const delay = animate && isDelayed ? { "--delay": `${(index - startDelayIndex) * 200}ms`} :{};

        const className=`Project ${animate ? '' : 'no-animate'} ${lightmode ? 'light' : 'dark'}`;

        const content = (
          <>
            <img src={project.image} alt={project.title} className='ProjectPic' />
            <h1>{project.title}</h1>
            <p>{project.description}</p>
          </>
        );

        return project.type === "external" ? (
          <a key={index} href={project.url} className={className} style={delay} target="_blank" rel="noopener noreferrer">
            {content}
          </a>
        ) : (
          <Link key={index} to={project.url} className={className} style={delay}>
            {content}
          </Link>
        );
      })}
    </div>
  );
}

export default ProjectenGrid;